import {
  getItem as getLocalStorageItem,
  setItem as setLocalStorageItem,
  removeItem as removeLocalStorageItem,
} from 'utils/storage';
import { CheckboxChangeEvent } from 'antd5/es/checkbox';
import { StyledNotification, StyledCheckbox } from './ReleaseNotification.style';

// update these to new values each quarter
export const storageKey = `q4-2025-release-notification-dismissed`;
export const highlightText = `Check out work container email notifications, dark mode, and more.`;
export const releaseNotesURL = `https://support.skyspecs.com/hc/en-us/articles/45842640817683-Q4-2025-Horizon-Release`;

export const shouldShowReleaseNotification = (): boolean => {
  return getLocalStorageItem(storageKey) !== 'true';
};

const FeatureNotificationContent: React.FunctionComponent = () => {
  const handleTogglePermanentDismissal = (event: CheckboxChangeEvent) => {
    if (event.target.checked) {
      setLocalStorageItem(storageKey, 'true');
    } else {
      removeLocalStorageItem(storageKey);
    }
  };

  return (
    <>
      <p>
        {highlightText}
        <br />
        <a href={releaseNotesURL} target="_blank" rel="noreferrer">
          See release notes for more info.
        </a>
      </p>
      <StyledCheckbox onChange={handleTogglePermanentDismissal}>Don't show again</StyledCheckbox>
    </>
  );
};

export const getReleaseNotificationConfig = () => ({
  message: <StyledNotification>New Features Released!</StyledNotification>,
  description: <FeatureNotificationContent />,
  duration: 0,
  placement: 'bottomRight',
  classNames: 'new-feature-notification',
});
